import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
/**
 * Renders a yellow "DEMO" stripe at the top of the app whenever the backend's
 * /health endpoint reports `demoMode: true`. Silent on production.
 *
 * Fetches once on mount; if the backend is unreachable we render nothing
 * (no banner is the safe default — we never want to claim "demo" on prod).
 */
export default function DemoBanner() {
    const [demoMode, setDemoMode] = React.useState(false);
    React.useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                // Backend serves /health at the root (not under /api). When
                // REACT_APP_API_BASE is undefined (legacy webpack default), fall back
                // to dev's localhost:8080; in the demo and prod builds it is set
                // (empty string for same-origin demo, full URL for prod).
                const base = (process.env.REACT_APP_API_BASE !== undefined
                    ? process.env.REACT_APP_API_BASE
                    : 'http://localhost:8080').replace(/\/$/, '');
                const res = await fetch(`${base}/health`, { credentials: 'omit' });
                if (!res.ok)
                    return;
                const data = await res.json();
                if (!cancelled && data?.demoMode === true)
                    setDemoMode(true);
            }
            catch {
                /* ignore — no banner on network error */
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);
    if (!demoMode)
        return null;
    return (_jsx("div", { role: "status", "aria-label": "Demo environment notice", style: {
            background: '#facc15',
            color: '#1f2937',
            textAlign: 'center',
            fontWeight: 600,
            fontSize: 14,
            padding: '6px 12px',
            position: 'sticky',
            top: 0,
            zIndex: 9999,
            boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
        }, children: "\uD83C\uDFAC DEMO ENVIRONMENT \u2014 sample data only." }));
}
